module.exports = __webpack_public_path__ + "img/portfolio-portraits-001.49c0b37e.jpg";